export const userRoles = [
  { id: 1, name: 'PD' },
  { id: 2, name: 'PO' },
  { id: 3, name: 'MEAL MANAGER' },
  { id: 4, name: 'MEAL OFFICER' },
  { id: 5, name: 'PROGRAM MANAGER' },
  { id: 6, name: 'DPD' },
]
export function getUserRoleByID(id) {
  return userRoles.find((role) => role.id == id)
}

export const projects = [
  { id: 1, name: 'PICTS' },
  { id: 2, name: 'MDR' },
]
export function getProjectByID(id) {
  return projects.find((prj) => prj.id == id)
}

export const townshipGroups = [
  { id: 1, name: 'PICTS1' },
  { id: 2, name: 'PICTS2' },
  { id: 3, name: 'MDR1' },
  { id: 4, name: 'MDR2' },
]
export function getTownshipByID(id) {
  
  return townshipGroups.find((twg) => twg.id == id)
}
